import type { PublicUser } from "../lib/types";
export function Avatar({ user, size }: { user: PublicUser; size?: "lg" }) {
  return <span className={"avatar" + (size ? " " + size : "")} style={{ background: user.color }} aria-hidden="true">
    {(user.displayName || user.username).slice(0, 1).toUpperCase()}
  </span>;
}
